<section id="materiais" class="border-t border-line/40 bg-surface py-24 lg:py-32">
  <div class="site-container flex flex-col items-center gap-16 md:flex-row">
    <div class="flex-1">
      <h2 class="mb-6 text-3xl font-bold lg:text-4xl">{{ content.title }}</h2>
      <p class="mb-10 text-lg text-muted">{{ content.description }}</p>
      <ul class="space-y-4">
        @for (item of content.items; track item.title) {
          <li class="rounded-lg border border-line/60 bg-canvas/60 p-5">
            <div class="flex gap-4">
              <app-icon [name]="item.icon" class="mt-0.5 text-gold" />
              <div class="min-w-0 flex-1">
                <h3 class="font-sans text-base font-bold">
                  <a
                    [href]="item.href"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="inline-flex items-center gap-1 text-primary transition-colors hover:text-gold"
                  >
                    {{ item.title }}
                    <app-icon name="open_in_new" class="text-base" />
                    <span class="sr-only">(abre em nova aba)</span>
                  </a>
                </h3>
                <p class="mt-1 text-sm leading-relaxed text-muted">{{ item.description }}</p>

                <ul class="mt-4 flex flex-wrap gap-2" [attr.aria-label]="'Links de ' + item.title">
                  @for (link of item.links; track link.href) {
                    <li>
                      <a
                        [href]="link.href"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="inline-flex items-center gap-1.5 rounded-full border border-primary/20 bg-surface px-3 py-1.5 text-xs font-bold text-primary transition-colors hover:border-gold hover:text-gold"
                      >
                        <app-icon [name]="link.icon" class="text-base" />
                        {{ link.label }}
                        <span class="sr-only">de {{ item.title }} (abre em nova aba)</span>
                      </a>
                    </li>
                  }
                </ul>

                @if (item.language) {
                  <p class="mt-3 flex items-center gap-1 text-[11px] font-bold text-muted">
                    <app-icon name="translate" class="text-sm" />
                    {{ item.language }}
                  </p>
                }
              </div>
            </div>
          </li>
        }
      </ul>
    </div>

    <!-- Capa ilustrativa dos materiais -->
    <div class="w-full flex-1" aria-hidden="true">
      <div
        class="relative mx-auto flex aspect-square max-w-lg flex-col justify-between overflow-hidden rounded-xl border border-line bg-[radial-gradient(circle_at_50%_40%,var(--color-navy-600),var(--color-navy-950)_75%)] p-10 text-white shadow-2xl"
      >
        <p class="font-display text-3xl tracking-wide uppercase opacity-90">Clinical Audit</p>
        <div class="space-y-3 self-end rounded border border-white/60 p-6 text-right">
          <p class="font-accent text-5xl text-gold-300">Clinical</p>
          <p class="font-display text-xl tracking-widest uppercase">Audit Materials</p>
          <span class="block h-px bg-white/50"></span>
          <p class="text-xs font-bold tracking-[0.3em] uppercase opacity-70">ONA • JCI</p>
        </div>
        <app-icon name="fact_check" class="absolute -bottom-6 -left-6 text-[12rem] text-white/5" />
      </div>
    </div>
  </div>
</section>
